// 业务错误码
const codeMap: Record<string, string> = {};

export default codeMap;
